export default __webpack_public_path__ + "static/media/liveHelp.8990b677.svg";